import { create } from 'zustand';

import { createAgentDelegationTargetsSlice } from './actions';
import { AgentDelegationTargetsStore } from './types';

export const useAgentDelegationTargetsStore =
  create<AgentDelegationTargetsStore>()((set, get, store) => ({
    ...createAgentDelegationTargetsSlice(set, get, store),
  }));
